import { z } from 'zod';
import { NotebookQuerySchema } from './notebook.js';
// Get Notebook
export const GetNotebookForCohortPathRequestSchema = z.object({
    cohort: z.string(),
    entityId: z.string(),
});
export const GetNotebookForCohortRequestSchema = GetNotebookForCohortPathRequestSchema;
export const GetNotebookForCohortResponseSchema = NotebookQuerySchema;
